import { render } from "./cpt-link-card.vue?vue&type=template&id=4a939d41"
import script from "./cpt-link-card.vue?vue&type=script&lang=js"
export * from "./cpt-link-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__